module.exports = __webpack_public_path__ + "static/shifra-logo-e87134b632a13a8e2c7b1bf729fb7b02.png";